import { render } from "./dondeycuando.vue?vue&type=template&id=223bd7d0&scoped=true"
import script from "./dondeycuando.vue?vue&type=script&lang=js"
export * from "./dondeycuando.vue?vue&type=script&lang=js"

import "./dondeycuando.vue?vue&type=style&index=0&id=223bd7d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223bd7d0"]])

export default __exports__